export const getTenantIdFromResponse = (response) => {
  const payload = response?.data ?? response;
  const tenant = payload?.data ?? payload?.success_res ?? payload;

  return tenant?._id ?? tenant?.id ?? payload?._id ?? payload?.id ?? null;
};

export const getTenantCheckUpdatePayload = (data, tenantId) => {
  const payload = { ...data, id: tenantId };
  delete payload.role;
  return payload;
};
